module.exports = __webpack_public_path__ + "img/icone-agro-analise.517c6a56.svg";